<template>
  <!-- パスワード再設定画面 -->
  <CContainer class="d-flex flex-column justify-content-center min-vh-100" style="width:480px">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <ValidationObserver ref="obs" v-slot="ObserverProps">
                <CForm>
                  <h1>パスワード再設定</h1>
                  <p class="text-muted">新しいパスワードを入力してください。</p>
                  <CRow>
                    <CCol sm="8">
                      <ValidationProvider
                        name="新しいパスワード"
                        rules="required|password"
                        v-slot="ProviderProps"
                      >
                        <label>
                          新しいパスワード
                          <span class="asterisk">*</span>
                        </label>
                        <CInput
                          :type="switchText"
                          v-model="newPassword"
                          @focus="showPassword = true"
                          @blur="showPassword = false"
                          description="英数字混在で8文字以上20文字以下で入力してください。記号の入力も可能です。"
                        />
                        <p class="error">
                          <font color="red">{{ ProviderProps.errors[0] }}</font>
                        </p>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="8">
                      <ValidationProvider
                        name="新しいパスワード(確認)"
                        rules="required|password|check:新しいパスワード"
                        v-slot="ProviderProps"
                      >
                        <label>
                          新しいパスワード(確認)
                          <span class="asterisk">*</span>
                        </label>
                        <CInput
                          :type="switchText"
                          v-model="confirmPassword"
                          @focus="showPassword = true"
                          @blur="showPassword = false"
                        />
                        <p class="error">
                          <font color="red">{{ ProviderProps.errors[0] }}</font>
                        </p>
                      </ValidationProvider>
                    </CCol>
                  </CRow>
                  <save-button
                    :label="'パスワードを変更'"
                    :loading="loading"
                    :disabled="ObserverProps.invalid"
                    @click="changePassword"
                    class="btn btn-info"
                  />
                </CForm>
              </ValidationObserver>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import axios from "axios";
import ConstList from "./../../ConstList";
import SaveButton from '../../common/SaveButton';
export default {
  components: { SaveButton },
  props: {
    id: {
      type: String
    },
    token: {
      type: String
    }
  },
  data() {
    return {
      id: "",
      token: "",
      newPassword: "",
      confirmPassword: "",
      showPassword: false,
      loading: false,
    };
  },
  computed: {
    // フォームをクリックすることでパスワード表示の切り替えを可能にする処理
    switchText() {
      return this.showPassword ? "text" : "password";
    }
  },
  methods: {
    // パスワードを送信
    changePassword: function() {
      this.loading = true;
      const item = {
        id: this.id,
        token: this.token,
        password: this.newPassword
      }
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/password/reset", item)
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            this.$router.push({
              name: "ResetComplete"
            });
          } else {
            this.errors.push(ConstList.NORMAL_ERROR);
            alert("パスワードの再設定が失敗しました。");
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>

</style>

